import React, { useState, useEffect, useContext } from "react";

import Dropdown from "./dropdown/dropdown.js";
import Callpage from "./callPage/Callpage.js";
import SIP, { UA, Session } from "sip.js";
import Dash from "./webphoneDown/Dash.js";
import CallPageDown from "./webphoneDown/CallPageDown.js";
import axios from "axios";
import Reconnect from "./dropdown/reconnect.js";
import CryptoJS from "crypto-js";
import { notification } from "antd";
import { Context } from "../themeContext.js";
import { useTranslation } from "react-i18next";
import { decryptC } from "../utils/util.js";
var check;
var Phone = {
  config: {},
};

var monPoste;

const incoming_2 = new Audio("./sounds/second_ring.mp3");
incoming_2.loop = true;
const incoming = new Audio("./sounds/ring.ogg");
incoming.loop = true;
const outgoing = new Audio("./sounds/ringback.ogg");
outgoing.loop = true;
const fin = new Audio("./sounds/callend.ogg");

function playIncomingSound() {
  const audio = allSession.length === 1 ? incoming : incoming_2;

  audio.play().catch((error) => {
    console.error("Error playing audio:", error);
  });
}

function pauseAudio(sound, playFin = false) {
  sound.pause();
  // sound.src = "";

  if (playFin) fin.play();
}
var tab = [];
var waitingForConferenceCall = false;
var conferenceTargetId = false;
var echecCurrentAppel = {};
var allSession = [];
const compte = localStorage.getItem("compte");
const posteCol = localStorage.getItem("poste");
const token = localStorage.getItem("AccessToken");
const BackendURL = window.BackendURLCmk;

const getUUID = () => {
  const keySize = 256 / 8; // 256 bits
  const randomBytes = new Uint8Array(keySize);
  crypto.getRandomValues(randomBytes);
  const secret_key = Array.from(randomBytes, (byte) =>
    byte.toString(32).padStart(2, "0")
  ).join("");

  return secret_key;
};

var CryptoJSAesJson = {
  stringify: function (cipherParams) {
    var j = { ct: cipherParams.ciphertext.toString(CryptoJS.enc.Base64) };
    if (cipherParams?.iv) j.iv = cipherParams.iv.toString();
    if (cipherParams?.salt) j.s = cipherParams.salt.toString();
    return JSON.stringify(j);
  },
  parse: function (jsonStr) {
    var j = JSON.parse(jsonStr);
    var cipherParams = CryptoJS.lib.CipherParams.create({
      ciphertext: CryptoJS.enc.Base64.parse(j.ct),
    });
    if (j.iv) cipherParams.iv = CryptoJS.enc.Hex.parse(j.iv);
    if (j.s) cipherParams.salt = CryptoJS.enc.Hex.parse(j.s);
    return cipherParams;
  },
};

Date.prototype.yyyymmdd = function () {
  var mm = this.getMonth() + 1; // getMonth() is zero-based
  var dd = this.getDate();
  var hh = this.getHours();
  var mi = this.getMinutes();
  return [
    this.getFullYear(),
    (mm > 9 ? "" : "0") + mm,
    (dd > 9 ? "" : "0") + dd,
    (hh > 9 ? "" : "0") + hh,
  ].join("");
};

function mixAudioStreams(MultiAudioTrackStream) {
  var audioContext = null;
  try {
    window.AudioContext = window.AudioContext || window.webkitAudioContext;
    audioContext = new AudioContext();
  } catch (e) {
    return MultiAudioTrackStream;
  }
  var mixedAudioStream = audioContext.createMediaStreamDestination();
  MultiAudioTrackStream.getAudioTracks().forEach(function (audioTrack) {
    var srcStream = new MediaStream();
    srcStream.addTrack(audioTrack);
    var streamSourceNode = audioContext.createMediaStreamSource(srcStream);
    streamSourceNode.connect(mixedAudioStream);
  });
  return mixedAudioStream.stream;
}
function requestNotificationPermission() {
  Notification.requestPermission(function (permission) {});
}

// stateObject.cmkPhone = new UA(Phone.config);

//   var s = stateObject.cmkPhone.invite('24651297', {
//     media: {
//         stream: ctxSip.Stream,
//         constraints: { audio: true, video: false },
//         render: {
//             remote: new Audio(),
//         },
//         RTCConstraints: { "optional": [{ 'DtlsSrtpKeyAgreement': 'true' }] }
//     }
// });

function PhoneCpt({ navbar, isOpen, maekeUp }) {
  const infoTag = localStorage.getItem("infoTag");
  const idTag = localStorage.getItem("idTag");
  // const encodedString = utf8.encode(infoTag);
  var tag = CryptoJS.AES.decrypt(idTag, "m@123").toString(CryptoJS.enc.Utf8);
  var tagInfo = CryptoJS.AES.decrypt(infoTag, tag).toString(CryptoJS.enc.Utf8);
  var tagInfoSplit = tagInfo.split("/*/");

  var date = new Date();
  ////////////////////////////////////////////////////////////////////////////////// old decrypted
  // var decrypted = JSON.parse(
  //   // CryptoJS.AES.decrypt(JSON.stringify(crypto), date.yyyymmdd(), {
  //   CryptoJS.AES.decrypt(infoTag, tag, {
  //     format: CryptoJSAesJson,
  //   }).toString(CryptoJS.enc.Utf8)
  // );

  const extraHeaders = [`X-Custom-Header: ${token}`];
  ////////////////////////////////////////////////////////////////////////////////// old decrypted
  var name = decryptC(tagInfoSplit[0]);
  var pwd = decryptC(tagInfoSplit[1]);
  var port = decryptC(tagInfoSplit[2]);
  const [stateObject, dispatch] = useContext(Context);
  const { t } = useTranslation("common");
  const [state, setState] = useState("start");
  // const [re, setRe] = useState(true)
  const [session, setSession] = useState([]);
  const [activecall, setActivecall] = useState("");
  const [acceptappel, setAcceptappel] = useState(false);
  const [openmodel, setOpenmodel] = useState(false);
  const [holdCall, setHoldCall] = useState(false);
  const [muteCall, setMuteCall] = useState(false);
  const [pingColor, setPingColor] = useState("");
  const [echecAppel, setEchecAppel] = useState({});
  const [backHome, setBackHome] = useState("");
  const [activeTransfert, setActiveTransfert] = useState(undefined);

  const addSession = (session, otherAction = "") => {
    const isExist = allSession.find(
      (old_s) =>
        old_s?.uuid === session?.uuid ||
        old_s?.remoteIdentity?.uri?.user === session?.remoteIdentity?.uri?.user
    );
    if (!isExist) {
      allSession[allSession.length] = session;
      setSession((all_s) => [...all_s, session]);
    }
    if (otherAction === "click") return !isExist;
    else if (otherAction === "holding") {
      if (activecall !== "") holdSession(activecall);
    }
  };
  const removeSession = (session) => {
    setSession((prev) =>
      prev.filter(
        (s1) =>
          s1.uuid !== session.uuid ||
          s1?.remoteIdentity?.uri?.user !== session?.remoteIdentity?.uri?.user
      )
    );
    allSession = allSession.filter(
      (s1) =>
        s1.uuid !== session.uuid ||
        s1?.remoteIdentity?.uri?.user !== session?.remoteIdentity?.uri?.user
    );
    dispatch({
      type: "SET_REFRESH_CONTENT_JOURNAL",
    });
  };
  const openNotificationWithIcon = (type, placement, message) => {
    notification[type]({
      message: message,
      placement,
      duration: 10,
    });
  };
  const checkMicrophonePermission = async () => {
    const constraints = {
      audio: true,
      video: false,
    };
    try {
      const stream = await navigator.mediaDevices.getUserMedia(constraints);
      if (stream) {
        stream.getTracks().forEach(function (track) {
          track.stop();
        });
        return true;
      } else return false;
    } catch (error) {
      return false;
    }
  };
  useEffect(() => {
    const callFunction = () => {
      switch (stateObject?.makeCall?.type) {
        case "VIDEO":
          callClickVideo(stateObject?.makeCall?.number);
          break;
        case "CALL":
          tab = [
            ...tab,
            {
              poste: stateObject?.makeCall?.number,
              nom: stateObject?.makeCall?.nom,
              lien_photo_poste_interne: stateObject?.makeCall?.image,
            },
          ];
          callClick(stateObject?.makeCall?.number);
          break;
        default:
          break;
      }
    };
    if (!stateObject?.makeCall?.number) return;
    callFunction();
  }, [stateObject?.makeCall]);
  useEffect(() => {
    if (Notification.permission !== "denied") {
      requestNotificationPermission();
    }
    let config1 = {
      headers: {
        Authorization: token,
      },
    };
    axios
      .get(
        `https://${BackendURL}:4444/${window.switchAPI}/Api/WS/ColleguesIPBXV3APIPROFIL?compte=${compte}&poste=${posteCol}`,
        config1
        // config
      )
      .then((res) => {
        tab = [...tab, res.data.collegues];
      })
      .catch((err) => {
        if (err == "Error: Request failed with status code 401") {
          // var link = "/";
          // window.location.replace(link);
        } else {
          // console.log("AXIOS ERROR: ", err);
        }
      });

    Phone = {
      config: {
        // autostart: true,
        register: true,
        password: pwd,
        displayName: name,
        uri: "sip:" + name + "@" + BackendURL,
        // wsServers: "wss://" + BackendURL + ":" + port + "/ws",
        wsServers: [
          {
            // First connection attempt
            ws_uri: "wss://" + BackendURL + ":8089/ws",
            weight: 10000,
          },
          {
            ws_uri: "wss://" + window.BackendURLCmkBack + ":8089/ws",
            weight: 1,
          },
        ],
        keepAliveInterval: 2,
        traceSip: true,
        log: {
          level: window.debug === true ? 3 : 0,
        },
        turnServers:
          window.isAllowed === true
            ? {
                urls: "turn:" + window.serverURL + ":" + window.PortICE,
                username: process.env.REACT_APP_TURN_LOGIN,
                password: process.env.REACT_APP_TURN_PASSWORD,
              }
            : undefined,
        hackWssInTransport: true,
        wsServerMaxReconnection: 5,
        wsServerReconnectionTimeout: 2,
        connectionRecoveryMaxInterval: 5,
        connectionRecoveryMinInterval: 2,
        connectionTimeout: 1,
        registerExpires: 10,
        allowLegacyNotifications: true,
        noAnswerTimeout: 300,

        // hackWssInTransport: true,
        // wsServerMaxReconnection: 15,
        // wsServerReconnectionTimeout: 5,
        // connectionRecoveryMaxInterval: 10,
        // connectionRecoveryMinInterval: 2,
        // registerExpires: 10,
        // allowLegacyNotifications: true,
      },
    };
    function createUA() {
      const cmkPhone = new UA(Phone.config);
      dispatch({ type: "INITIAL_CMK_PHONE", payload: cmkPhone });

      if (!token) {
        cmkPhone?.unregister();
        cmkPhone?.stop();
      } else cmkPhone.start();
      cmkPhone.on("connected", function (e) {
        // console.log("connected");
      });

      cmkPhone.on("disconnected", function (e) {
        openNotificationWithIcon(
          "error",
          "bottomRight",
          "Webphone déconnecté. Tentatives de reconnexions lancées ..."
        );
        // setPingColor("red");
        // console.log("disconnected");
        // if (navigator.onLine) {
        //   console.log("online_");
        //   const ipPublic = _axios
        //     .get(
        //       // config
        //     )
        //     .then(function (response) {
        //       const declareIp = _axios
        //         .get(
        //             response.data.ip_public
        //           }&poste=${UserService.getPoste()}`
        //           // config
        //         )
        //         .then(function (response) {})
        //         .catch(function (error) {});
        //     })
        //     .catch(function (error) {});
        // } else {
        //   console.log("offline");
        // }
      });

      cmkPhone.on("registered", function (e) {
        if (window.BackendURLCmkBack !== window.BackendURLCmk) {
          if (
            cmkPhone.transport.server.sip_uri ===
            "<sip:" + window.BackendURLCmkBack + ":8089;transport=ws;lr>"
          ) {
            var config = {
              headers: {
                Authorization: token,
              },
            };

            const result = axios
              .get(
                `https://${BackendURL}:4444/${window.switchAPI}/Api/WS/TestServerVoipAPI?compte=${compte}&poste=${posteCol}`,
                config
                // config
              )
              .then(function (response) {
                if (response.data.etat_voip_server === "OK") {
                  cmkPhone.stop();
                  createUA();
                  console.log("serverok", response.data.etat_voip_server);
                }
              });
          }
        }
        // openNotificationWithIcon("success", "bottomRight", "Webphone connecté");
        // toast.success("Yeay! New data is here.");

        setPingColor("green");
        // document.getElementById("pingStatus").classList.remove("bg-red-500");
        // document.getElementById("pingIcon").classList.remove("text-red-400");
        // document.getElementById("pingStatus").classList.add("bg-green-500");
        // document.getElementById("pingIcon").classList.add("text-green-400");
      });

      cmkPhone.on("registrationFailed", function (e) {
        console.log("registrationFailed");
        // setPingColor("red");
      });

      cmkPhone.on("unregistered", function (e) {
        const notif = new Notification("Webphone deconnecté", {
          icon: "/" + window.switchAPI + ".",
        });
        notif.addEventListener("click", function () {
          window.parent.focus();
        });
        // console.log("unregistered");
        openNotificationWithIcon(
          "error",
          "bottomRight",
          "Webphone déconnecté. Tentatives de reconnexions lancées ..."
        );
        setPingColor("red");
        // if (navigator.onLine) {
        //   console.log("online");
        //   const ipPublic = _axios
        //     .get(
        //       // config
        //     )
        //     .then(function (response) {
        //       const declareIp = _axios
        //         .get(
        //             response.data.ip_public
        //           }&poste=${UserService.getPoste()}`
        //           // config
        //         )
        //         .then(function (response) {})
        //         .catch(function (error) {});
        //     })
        //     .catch(function (error) {});
        // } else {
        //   console.log("offline");
        // }
        // document
        //   .getElementById("pingStatus")
        //   .classList.remove("bg-green-500");
        // document
        //   .getElementById("pingIcon")
        //   .classList.remove("text-green-400");
        // document.getElementById("pingStatus").classList.add("bg-red-500");
        // document.getElementById("pingIcon").classList.add("text-red-400");
      });

      cmkPhone.on("userMediaFailed", function (e) {
        // Display an error message to the user
        const errorMessage =
          "Failed to access media devices. Please check your microphone and camera settings.";
        // You can use any method (e.g., displaying an alert, updating a UI element, etc.) to show the error message to the user
        console.error(errorMessage);
      });

      cmkPhone.on("invite", function (incomingSession) {
        try {
          let s = incomingSession;
          // notifyMe(s.remoteIdentity.uri.user);
          const notif = new Notification(
            (window.switchAPI === "comunik_ipbx" ? "Comunik" : "Go Voice") +
              " - Appel entrant",
            {
              body: s.remoteIdentity.uri.user,
              icon: "/" + window.switchAPI + ".png",
              requireInteraction: true,
            }
          );
          notif.addEventListener("click", function () {
            window.parent.focus();
          });
          if (s.request.headers["Call-Info"] !== undefined) {
            s.accept({
              media: {
                constraints: { audio: true, video: false },
                render: {
                  remote: new Audio(),
                },
                RTCConstraints: {
                  optional: [{ DtlsSrtpKeyAgreement: "true" }],
                },
              },
            });
            s.statusAppel = "accepted";
          } else {
            s.direction = "incoming";
            s.statusAppel = "ringing";
          }
          if (
            s.mediaHandler.peerConnection.remoteDescription.sdp.indexOf(
              "video"
            ) === -1
          ) {
            s.type = "audio";
          } else {
            s.type = "video";
          }

          s.ismute = "no";
          s.conf = "null";
          s.uuid = getUUID();
          addSession(s);

          // if (allSession.length === 1) {
          //   incoming?.play();
          // } else {
          //   incoming_2?.play();
          // }
          playIncomingSound();

          s.on("progress", function (e) {});
          s.on("accepted", function (e) {
            console.log("id_appel2", Object.values(s.request.headers)[11]);
            pauseAudio(incoming, false);
            pauseAudio(incoming_2, false);
            s.statusAppel = "accepted";

            s.date = Date.now();

            setActivecall(s);
          });
          s.on("bye", function (e) {
            if (
              document.getElementById("remoteVideo") &&
              document.getElementById("localVideo")
            ) {
              document.getElementById("remoteVideo").style.display = "none";
              document.getElementById("localVideo").style.display = "none";
            }
            pauseAudio(incoming, true);
            pauseAudio(incoming_2, false);
            // console.log("bye", session);
            if (s.conf !== "null") {
              s.conf.conf = "null";
            }
            setActivecall("");

            removeSession(s);
            // setSession(session.splice(session.indexOf(s), 1))

            // if (allSession.length !== 0) {
            //   setActivecall(allSession[allSession.length - 1]);
            // } else {
            //   setActivecall("");
            // }
          });
          s.on("rejected", function (e) {
            if (
              document.getElementById("remoteVideo") &&
              document.getElementById("localVideo")
            ) {
              document.getElementById("remoteVideo").style.display = "none";
              document.getElementById("localVideo").style.display = "none";
            }

            pauseAudio(incoming, true);
            pauseAudio(incoming_2, false);

            removeSession(s);

            // setSession(session.splice(session.indexOf(s), 1))

            // if (allSession.length !== 0) {
            //   setActivecall(allSession[allSession.length - 1]);
            // } else {
            //   setActivecall("");
            // }
          });

          s.on("cancel", function (e) {
            try {
              if (
                document.getElementById("remoteVideo") &&
                document.getElementById("localVideo")
              ) {
                document.getElementById("remoteVideo").style.display = "none";
                document.getElementById("localVideo").style.display = "none";
              }
              pauseAudio(incoming, false);
              pauseAudio(incoming_2, false);

              removeSession(s);

              setActivecall("");

              // setSession(session.splice(session.indexOf(s), 1))

              // if (allSession.length !== 0) {
              //   setActivecall(allSession[allSession.length - 1]);
              // } else {
              //   setActivecall("");
              // }
            } catch (error) {
              console.log(error);

              return;
            }
          });
          s.on("failed", function (e) {
            try {
              if (
                document.getElementById("remoteVideo") &&
                document.getElementById("localVideo")
              ) {
                document.getElementById("remoteVideo").style.display = "none";
                document.getElementById("localVideo").style.display = "none";
              }
              pauseAudio(incoming, false);
              pauseAudio(incoming_2, false);
              removeSession(s);

              //change session (last call)
              // if (allSession.length !== 0) {
              //   setActivecall(allSession[allSession.length - 1]);
              // } else {
              //   setActivecall("");
              // }
            } catch (error) {
              console.log(error);

              return;
            }
          });
        } catch (error) {
          console.log(error);
        }
      });
    }

    createUA();
  }, []);

  if (session.length === 0) {
    maekeUp(0);
  } else {
    maekeUp(1);
  }

  function specialCharacters(number) {
    // if (number.charAt(0) === "+") {
    //   number = "00" + number.substr(1);
    // }
    return number
      .replace(/ /g, "")
      .replace(/[`~!@$%^&()_|\-=?;:'",.<>\{\}\[\]\\\/]/gi, "")
      .replace(/[a-z]/gi, "");
  }

  function sipMergeSessions(sessionId, targetSessionId) {
    var current = sessionId;
    var target = targetSessionId;
    var currentRtpReceivers =
      current.mediaHandler.peerConnection.getReceivers();
    var currentRtpSenders = current.mediaHandler.peerConnection.getSenders();
    var targetRtpReceivers = target.mediaHandler.peerConnection.getReceivers();
    var targetRtpSenders = target.mediaHandler.peerConnection.getSenders();

    var targetOutputStream = new MediaStream();
    var currentOutputStream = new MediaStream();
    currentRtpReceivers.forEach(function (RTPReceiver) {
      if (RTPReceiver.track && RTPReceiver.track.kind == "audio") {
        targetOutputStream.addTrack(RTPReceiver.track);
      }
    });

    targetRtpReceivers.forEach(function (RTPReceiver) {
      if (RTPReceiver.track && RTPReceiver.track.kind == "audio") {
        currentOutputStream.addTrack(RTPReceiver.track);
      }
    });

    targetRtpSenders.forEach(function (RTPSender) {
      if (RTPSender.track && RTPSender.track.kind == "audio") {
        target.data.AudioSourceTrack = RTPSender.track;
        targetOutputStream.addTrack(RTPSender.track);
        var mixedAudioTracks =
          mixAudioStreams(targetOutputStream).getAudioTracks()[0];
        mixedAudioTracks.isMixedTrack = true;
        RTPSender.replaceTrack(mixedAudioTracks);
      }
    });

    currentRtpSenders.forEach(function (RTPSender) {
      if (RTPSender.track && RTPSender.track.kind == "audio") {
        current.data.AudioSourceTrack = RTPSender.track;
        currentOutputStream.addTrack(RTPSender.track);
        var mixedAudioTracks =
          mixAudioStreams(currentOutputStream).getAudioTracks()[0];
        mixedAudioTracks.isMixedTrack = true;
        RTPSender.replaceTrack(mixedAudioTracks);
      }
    });
  }

  const cancelEchecAppel = () => {
    setEchecAppel({});
    echecCurrentAppel = {};
  };

  const ConferenceCall = (number) => {
    try {
      if (number !== "" && number !== monPoste) {
        setBackHome("");
        waitingForConferenceCall = true;
        conferenceTargetId = activecall;
        let s = stateObject.cmkPhone.invite(number, {
          extraHeaders,
          media: {
            stream: Phone.Stream,
            constraints: { audio: true, video: false },
            render: {
              remote: new Audio(),
            },
            RTCConstraints: { optional: [{ DtlsSrtpKeyAgreement: "true" }] },
          },
        });

        s.conf = "inviter";
        activecall.conf = s;
        s.direction = "outgoing";
        s.statusAppel = "ringing";
        s.uuid = getUUID();
        addSession(s);
        setState("start");

        s.on("progress", function (e) {
          outgoing.play();
        });
        s.on("accepted", function (e) {
          pauseAudio(outgoing, false);
          s.statusAppel = "accepted";

          s.date = Date.now();
          if (waitingForConferenceCall) {
            sipMergeSessions(s, conferenceTargetId);
            waitingForConferenceCall = false;
            conferenceTargetId = false;
          }
        });
        s.on("bye", function (e) {
          pauseAudio(outgoing, true);

          // console.log("bye");
          activecall.conf = "null";
          removeSession(s);

          setActivecall("");

          // setSession(session.splice(session.indexOf(s), 1))

          // if (session.length !== 0) {
          //   setActivecall(session[session.length - 1]);
          // } else {
          //   setActivecall("");
          // }
        });
        s.on("rejected", function (e) {
          pauseAudio(outgoing, true);

          activecall.conf = "null";
          removeSession(s);

          setActivecall("");

          // setSession(session.splice(session.indexOf(s), 1))

          // if (allSession.length !== 0) {
          //   setActivecall(allSession[allSession.length - 1]);
          // } else {
          //   setActivecall("");
          // }
        });
        s.on("cancel", function (e) {
          try {
            pauseAudio(outgoing, false);

            removeSession(s);

            // setSession(session.splice(session.indexOf(s), 1))
            setActivecall("");

            // if (allSession.length !== 0) {
            //   setActivecall(allSession[allSession.length - 1]);
            // } else {
            //   setActivecall("");
            // }
          } catch (error) {
            console.log(error);
            return;
          }
        });
        s.on("failed", function (e) {
          try {
            if (
              document.getElementById("remoteVideo") &&
              document.getElementById("localVideo")
            ) {
              document.getElementById("remoteVideo").style.display = "none";
              document.getElementById("localVideo").style.display = "none";
            }

            pauseAudio(outgoing, false);

            removeSession(s);

            setActivecall("");

            //change session (last call)
            // if (allSession.length !== 0) {
            //   setActivecall(allSession[allSession.length - 1]);
            // } else {
            //   setActivecall("");
            // }
          } catch (error) {
            console.log(error);
            return;
          }
        });
      }
    } catch (error) {
      console.log(error);
      return;
    }
  };
  const transfertCall = (target) => {
    if (target !== "" && target !== monPoste) {
      let referredBy = new SIP.URI("sip", posteCol, BackendURL, 5060);

      activecall?.refer(target, {
        extraHeaders: [
          `Referred-By: <${referredBy?.toString()}>`,
          ...extraHeaders,
        ],
      });
      removeSession(activecall);

      if (allSession.length !== 0) {
        setActivecall(allSession[allSession.length - 1]);
      } else {
        setActivecall("");
      }
    }
  };
  const transfertCallAcc = (target, dest) => {
    try {
      if (target !== "") {
        target.refer(dest);
        removeSession(dest);

        // setSession(session.splice(session.indexOf(s), 1))
        setActiveTransfert(undefined);
        if (allSession.length !== 0) {
          allSession[allSession.length - 1].statusAppel = "hold";
          setActivecall(allSession[allSession.length - 1]);
        } else {
          setActivecall("");
        }
      }
    } catch (error) {
      console.log(error);
      return;
    }
  };

  const callTransfert = (number) => {
    try {
      if (number !== "" && number !== monPoste) {
        echecCurrentAppel = {};
        setBackHome("");

        let s = stateObject.cmkPhone.invite(number, {
          extraHeaders,
          media: {
            stream: Phone.Stream,
            constraints: { audio: true, video: false },
            render: {
              remote: new Audio(),
            },
            RTCConstraints: { optional: [{ DtlsSrtpKeyAgreement: "true" }] },
          },
        });
        setActiveTransfert(s);
        s.conf = "null";
        s.direction = "outgoing";
        s.selfCancel = true;
        s.ismute = "no";
        s.statusAppel = "ringing";
        s.uuid = getUUID();
        setState("start");

        addSession(s, "holding");

        s.on("progress", function (e) {
          outgoing.play();
        });
        s.on("accepted", function (e) {
          pauseAudio(outgoing, false);

          s.statusAppel = "accepted";
          s.date = Date.now();
          setActivecall(s);
        });
        s.on("bye", function (e) {
          pauseAudio(outgoing, true);

          setActiveTransfert((p) => {
            if (p) p.statusAppel = "end";
            return p;
          });
          if (s.conf !== "null") {
            s.conf.conf = "null";
          }
          removeSession(s);

          setActivecall("");

          //  activecall?.unhold();
          // setSession(session.splice(session.indexOf(s), 1))
          // if (allSession.length !== 0) {
          //   allSession[allSession.length - 1].statusAppel = "hold";
          //   setActivecall(allSession[allSession.length - 1]);
          //   //          activecallLocal = allSession[allSession.length - 1];
          // } else {
          //   setActivecall("");
          //   // activecallLocal = "";
          // }
        });
        s.on("rejected", function (e) {
          setActiveTransfert((p) => {
            if (p) p.statusAppel = "end";
            return p;
          });
          if (s.selfCancel) {
            setEchecAppel(s);
            echecCurrentAppel = s;
          }

          pauseAudio(outgoing, true);

          removeSession(s);

          setActivecall("");

          // setSession(session.splice(session.indexOf(s), 1))

          // if (allSession.length !== 0) {
          //   setActivecall(allSession[allSession.length - 1]);
          //   // activecallLocal = allSession[allSession.length - 1];
          // } else {
          //   setActivecall("");
          //   //  activecallLocal = "";
          // }
        });
        s.on("cancel", function (e) {
          try {
            pauseAudio(outgoing, false);

            setActiveTransfert((p) => {
              if (p) p.statusAppel = "end";
              return p;
            });

            removeSession(s);

            // setSession(session.splice(session.indexOf(s), 1))

            setActivecall("");
          } catch (error) {
            console.log(error);
            return;
          }
        });
        s.on("failed", function (e) {
          try {
            if (
              document.getElementById("remoteVideo") &&
              document.getElementById("localVideo")
            ) {
              document.getElementById("remoteVideo").style.display = "none";
              document.getElementById("localVideo").style.display = "none";
            }
            pauseAudio(outgoing, false);

            removeSession(s);

            //change session (last call)
            setActivecall("");
          } catch (error) {
            console.log(error);
            return;
          }
        });
      }
    } catch (error) {
      console.log(error);

      return;
    }
  };
  const holdSession = (session) => {
    if (session.statusAppel === "holding") {
      allSession.map((all_s) => {
        if (all_s?.uuid === session?.uuid) {
          session.unhold();
          all_s.statusAppel = "answered";
        }
        return all_s;
      });
      setSession((prev) =>
        prev.map((all_s) => {
          if (all_s.uuid === session?.uuid) {
            session.unhold();
            all_s.statusAppel = "answered";
          }
          return all_s;
        })
      );
      setHoldCall(false);
    } else {
      console.log("session", allSession, session);
      allSession.map((all_s) => {
        if (all_s.uuid === session?.uuid) {
          session.hold();
          all_s.statusAppel = "holding";
        }
        return all_s;
      });
      setSession((prev) =>
        prev.map((all_s) => {
          if (all_s.uuid === session?.uuid) {
            session.hold();
            all_s.statusAppel = "holding";
          }
          return all_s;
        })
      );

      setHoldCall(true);
    }
  };

  const muteSession = (session) => {
    if (session.ismute === "yes") {
      allSession.map((all_s) => {
        if (all_s.uuid === session?.uuid) {
          session.unmute();
          session.ismute = "no";
        }
        return all_s;
      });
      setSession((prev) =>
        prev.map((all_s) => {
          if (all_s.uuid === session?.uuid) {
            session.unmute();
            session.ismute = "no";
          }
          return all_s;
        })
      );

      setMuteCall(false);
    } else {
      allSession.map((all_s) => {
        if (all_s.uuid === session?.uuid) {
          session.mute();
          session.ismute = "yes";
        }
        return all_s;
      });
      setSession((prev) =>
        prev.map((all_s) => {
          if (all_s.uuid === session?.uuid) {
            session.mute();
            session.ismute = "yes";
          }
          return all_s;
        })
      );
      setMuteCall(true);
    }
  };

  const hungUp = (sessionId) => {
    // console.log("ses1", session);
    try {
      sessionId.selfCancel = false;
      if (sessionId.statusAppel !== "ringing") {
        sessionId.bye();
      } else if (sessionId.reject) {
        sessionId.reject();
      } else if (sessionId.cancel) {
        sessionId.cancel();
      }
      setActiveTransfert(undefined);
    } catch (error) {
      pauseAudio(incoming, true);
      removeSession(sessionId);

      // if (allSession.length !== 0) {
      //   setActivecall(allSession[allSession.length - 1]);
      // } else {
      //   setActivecall("");
      // }
    }
  };

  const upBtn = async (session) => {
    try {
      const micIsActive = await checkMicrophonePermission();
      if (!micIsActive) {
        openNotificationWithIcon(
          "error",
          "bottomRight",
          t("mustAllowMicrophonePermission")
        );
        return;
      }
      allSession.map((all_s) => {
        if (activecall && all_s.uuid === activecall?.uuid) {
          activecall.hold();
          all_s.statusAppel = "holding";
        }
        return all_s;
      });
      setSession((prev) =>
        prev.map((all_s) => {
          if (activecall && all_s.uuid === activecall?.uuid) {
            activecall.hold();
            all_s.statusAppel = "holding";
          }
          return all_s;
        })
      );
      setHoldCall(false);
      await session.accept({
        media: {
          constraints: { audio: true, video: false },
          render: {
            remote: new Audio(),
          },
          RTCConstraints: { optional: [{ DtlsSrtpKeyAgreement: "true" }] },
        },
      });
      session.date = Date.now();
    } catch (error) {
      console.log(error);
    }
  };

  const upBtnVideo = (session) => {
    document.getElementById("remoteVideo").style.display = "block";
    document.getElementById("localVideo").style.display = "block";

    session.statusAppel = "accepted";
    if (activecall !== "") {
      activecall.hold();
      setActivecall(session);
    }
    session.accept({
      media: {
        constraints: { audio: true, video: true },
        render: {
          remote: document.getElementById("remoteVideo"),
          local: document.getElementById("localVideo"),
        },
        RTCConstraints: { optional: [{ DtlsSrtpKeyAgreement: "true" }] },
      },
    });
    session.date = Date.now();
  };

  const sendDTMF = (session, digit) => {
    if (session) {
      session.dtmf(digit);
    }
  };

  const changeSession = (session) => {
    if (activecall !== "") {
      allSession.map((all_s) => {
        if (activecall && all_s.uuid === activecall?.uuid) {
          activecall.hold();
          all_s.statusAppel = "holding";
        }
        return all_s;
      });
      setSession((prev) =>
        prev.map((all_s) => {
          if (activecall && all_s.uuid === activecall?.uuid) {
            activecall.hold();
            all_s.statusAppel = "holding";
          }
          return all_s;
        })
      );
      session.unhold();
      session.statusAppel = "answered";
      setActivecall(session);
    }
  };
  const closeBackHome = (e) => {
    setBackHome("");
  };
  const openBackHome = (e) => {
    setBackHome("newCall");
  };
  const openBackHomeConference = (e) => {
    setBackHome("conference");
  };

  const reconnectionWebphone = () => {
    check = setInterval(function () {
      let config = {
        headers: {
          Authorization: token,
        },
      };
      const result = axios
        .get(
          `https://${BackendURL}:4444/${window.switchAPI}/Api/WS/IpPublicIPBXV3API?compte=${compte}&poste=${posteCol}`,
          config
          // config
        )
        .then(function (response) {
          let config1 = {
            headers: {
              Authorization: token,
            },
          };
          const result1 = axios
            .get(
              `https://${BackendURL}:4444/${window.switchAPI}/Api/WS/IPCOMUNIKSOFTPHONEDECLARWS?compte=${compte}&adresse_ip=${response.data.ip_public}&poste=${posteCol}`,
              config1
              // config
            )
            .then(function (response) {
              clearInterval(check);
              setPingColor("green");
            })
            .catch(function (error) {});
        })
        .catch(function (error) {});
    }, 10000);
  };

  const callClick = async (number) => {
    try {
      const micIsActive = await checkMicrophonePermission();

      if (stateObject.isCalling) return;

      if (!micIsActive) {
        openNotificationWithIcon(
          "error",
          "bottomRight",
          t("mustAllowMicrophonePermission")
        );

        return;
      }

      if (number !== "" && number !== posteCol) {
        dispatch({
          type: "IS_CALLING",
          payload: true,
        });
        dispatch({
          type: "MAKE_CALL",
          payload: {
            nom: "",
            image: "",
            type: "",
            number: "",
          },
        });
        echecCurrentAppel = {};
        setBackHome("");
        if (document.getElementById("headlessui-portal-root") !== null) {
          document
            .getElementsByClassName("newCall")[0]
            ?.firstChild?.firstChild?.click();
        }

        let s = stateObject.cmkPhone.invite(specialCharacters(number), {
          extraHeaders,
          media: {
            stream: Phone.Stream,
            constraints: { audio: true, video: false },
            render: {
              remote: new Audio(),
            },
            RTCConstraints: { optional: [{ DtlsSrtpKeyAgreement: "true" }] },
          },
        });
        s.conf = "null";
        s.direction = "outgoing";
        s.selfCancel = true;
        s.ismute = "no";
        s.statusAppel = "ringing";
        s.uuid = getUUID();
        const completeCall = addSession(s, "click");
        console.log("completeCall", completeCall);

        setState("start");

        s.on("progress", function (e) {
          if (e.status_code === 183 && e.body && s.hasOffer && !s.dialog) {
            if (
              !e.hasHeader("require") ||
              e.getHeader("require").indexOf("100rel") === -1
            ) {
              if (s.mediaHandler.hasDescription(e)) {
                s.createDialog(e, "UAC");
              }
            }

            s.hasAnswer = true;

            s.dialog.pracked.push(e.getHeader("rseq"));
            s.status = Session.C.STATUS_EARLY_MEDIA;
            try {
              s.mediaHandler.setDescription(
                e,
                s.mediaHandler.mediaHint.constraints,
                s.modifiers
              );
              pauseAudio(outgoing, false);
            } catch (reason) {
              console.warn(reason);
              s.terminate({
                status_code: 488,
                reason_phrase: "Bad Media Description",
              });
            }
          } else {
            if (window.sipProgressStatusCodes.includes(e.status_code)) {
              outgoing.src = "/sounds/ringback.ogg";
              outgoing.play();
            }
          }
        });
        s.on("accepted", function (e) {
          console.log("id_appel2", Object.values(s.request.headers)[11]);
          pauseAudio(outgoing, false);

          s.statusAppel = "accepted";
          s.date = Date.now();
          setActivecall(s);
        });
        s.on("bye", function (e) {
          dispatch({
            type: "IS_CALLING",
            payload: false,
          });
          pauseAudio(outgoing, true);

          if (s.conf !== "null") {
            s.conf.conf = "null";
          }
          removeSession(s);

          // if (allSession.length !== 0) {
          //   setActivecall(allSession[allSession.length - 1]);
          // } else {
          //   setActivecall("");
          // }
        });
        s.on("rejected", function (e) {
          dispatch({
            type: "IS_CALLING",
            payload: false,
          });
          if (s.selfCancel) {
            setEchecAppel(s);
            echecCurrentAppel = s;
            console.log("rejj", s.selfCancel);
          }
          pauseAudio(outgoing, true);

          removeSession(s);

          setActivecall("");

          // setSession(session.splice(session.indexOf(s), 1))

          // if (allSession.length !== 0) {
          //   setActivecall(allSession[allSession.length - 1]);
          // } else {
          //   setActivecall("");
          // }
        });
        s.on("cancel", function (e) {
          try {
            dispatch({
              type: "IS_CALLING",
              payload: false,
            });
            pauseAudio(outgoing, false);
            removeSession(s);

            setActivecall("");

            // setSession(session.splice(session.indexOf(s), 1))

            // if (allSession.length !== 0) {
            //   setActivecall(allSession[allSession.length - 1]);
            // } else {
            //   setActivecall("");
            // }
          } catch (error) {
            console.log(error);
            return;
          }
        });
        s.on("failed", function (e) {
          try {
            dispatch({
              type: "IS_CALLING",
              payload: false,
            });
            if (
              document.getElementById("remoteVideo") &&
              document.getElementById("localVideo")
            ) {
              document.getElementById("remoteVideo").style.display = "none";
              document.getElementById("localVideo").style.display = "none";
            }
            pauseAudio(outgoing, false);

            removeSession(s);

            setActivecall("");

            //change session (last call)
            // if (allSession.length !== 0) {
            //   setActivecall(allSession[allSession.length - 1]);
            // } else {
            //   setActivecall("");
            // }
          } catch (error) {
            console.log(error);

            return;
          }
        });
      }
    } catch (error) {
      return;
    }
  };
  const callClickVideo = async (number) => {
    const micIsActive = await checkMicrophonePermission();

    if (!micIsActive) {
      openNotificationWithIcon(
        "error",
        "bottomRight",
        t("mustAllowMicrophonePermission")
      );

      return;
    }
    try {
      if (stateObject.isCalling) return;

      const inputNumber = number ?? document.getElementById("numDisplay").value;

      if (inputNumber !== "" && inputNumber !== monPoste) {
        dispatch({
          type: "IS_CALLING",
          payload: true,
        });
        dispatch({
          type: "MAKE_CALL",
          payload: {
            nom: "",
            image: "",
            type: "",
            number: "",
          },
        });
        let s = stateObject.cmkPhone.invite(inputNumber, {
          extraHeaders,
          media: {
            stream: Phone.Stream,
            constraints: { audio: true, video: true },
            render: {
              remote: document.getElementById("remoteVideo"),
              local: document.getElementById("localVideo"),
            },
            RTCConstraints: { optional: [{ DtlsSrtpKeyAgreement: "true" }] },
          },
        });
        s.type = "video";
        s.conf = "null";
        s.direction = "outgoing";
        s.ismute = "no";
        s.statusAppel = "ringing";
        s.uuid = getUUID();
        const completeCall = addSession(s, "click");
        if (!completeCall) {
          s.reject();
        }
        setState("start");

        s.on("progress", function (e) {
          outgoing.play();
          document.getElementById("remoteVideo").style.display = "block";
          document.getElementById("localVideo").style.display = "block";
          // setSession(session.splice(session.indexOf(s), 1))
        });
        s.on("accepted", function (e) {
          pauseAudio(outgoing, false);

          setActivecall(s);
          s.statusAppel = "accepted";

          s.date = Date.now();
        });
        s.on("bye", function (e) {
          pauseAudio(outgoing, true);
          dispatch({
            type: "IS_CALLING",
            payload: false,
          });
          removeSession(s);

          if (
            document.getElementById("remoteVideo") &&
            document.getElementById("localVideo")
          ) {
            document.getElementById("remoteVideo").style.display = "none";
            document.getElementById("localVideo").style.display = "none";
          }
          setActivecall("");

          // setSession(session.splice(session.indexOf(s), 1))

          // if (allSession.length !== 0) {
          //   setActivecall(allSession[allSession.length - 1]);
          // } else {
          //   setActivecall("");
          // }
        });
        s.on("rejected", function (e) {
          pauseAudio(outgoing, true);

          dispatch({
            type: "IS_CALLING",
            payload: false,
          });
          if (
            document.getElementById("remoteVideo") &&
            document.getElementById("localVideo")
          ) {
            document.getElementById("remoteVideo").style.display = "none";
            document.getElementById("localVideo").style.display = "none";
          }
          removeSession(s);

          setActivecall("");

          // setSession(session.splice(session.indexOf(s), 1))

          // if (allSession.length !== 0) {
          //   setActivecall(allSession[allSession.length - 1]);
          // } else {
          //   setActivecall("");
          // }
        });
        s.on("cancel", function (e) {
          try {
            dispatch({
              type: "IS_CALLING",
              payload: false,
            });
            pauseAudio(outgoing, false);

            if (
              document.getElementById("remoteVideo") &&
              document.getElementById("localVideo")
            ) {
              document.getElementById("remoteVideo").style.display = "none";
              document.getElementById("localVideo").style.display = "none";
            }
            // setSession(session.splice(session.indexOf(s), 1))
            removeSession(s);

            // setSession(session.splice(session.indexOf(s), 1))

            // if (allSession.length !== 0) {
            //   setActivecall(allSession[allSession.length - 1]);
            // } else {
            //   setActivecall("");
            // }
          } catch (error) {
            console.log(error);
            return;
          }
        });
        s.on("failed", function (e) {
          try {
            dispatch({
              type: "IS_CALLING",
              payload: false,
            });
            if (
              document.getElementById("remoteVideo") &&
              document.getElementById("localVideo")
            ) {
              document.getElementById("remoteVideo").style.display = "none";
              document.getElementById("localVideo").style.display = "none";
            }

            pauseAudio(outgoing, false);

            removeSession(s);

            //change session (last call)
            // if (allSession.length !== 0) {
            //   setActivecall(allSession[allSession.length - 1]);
            // } else {
            //   setActivecall("");
            // }
          } catch (error) {
            console.log(error);

            return;
          }
        });
      }
    } catch (error) {
      console.log(error);
    }
  };
  return (
    <div className="phone" style={{ width: "100%", borderRadius: "30px" }}>
      <video
        id="remoteVideo"
        style={{
          position: "fixed",
          height: "100%",
          width: "100%",
          zIndex: "-1",
          objectFit: "cover",
          borderRadius: "30px",
        }}
      ></video>
      <video
        id="localVideo"
        style={{
          position: "absolute",
          zIndex: "-1",
          right: "0",
          width: isOpen ? "25%" : "10%",
          borderRadius: "30px",
        }}
        muted
      ></video>

      <div className={"statusBar px-4 absolute top-0"} style={{ zIndex: "1" }}>
        {pingColor === "red" ? (
          <Reconnect
            navbar={navbar}
            reconnectionWebphone={reconnectionWebphone}
          />
        ) : (
          <div>
            {/* <span
            id="pingStatus"
            className={
              "animate-ping absolute left-4 inline-flex h-6 w-6 rounded-full  opacity-95 bg-" +
              pingColor +
              "-500 "
            }
          ></span> */}

            <svg
              id="pingIcon"
              xmlns="http://www.w3.org/2000/svg"
              className={"h-6 w-6 text-" + pingColor + "-400"}
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth="2"
            >
              {" "}
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M8.111 16.404a5.5 5.5 0 017.778 0M12 20h.01m-7.08-7.071c3.904-3.905 10.236-3.905 14.141 0M1.394 9.393c5.857-5.857 15.355-5.857 21.213 0"
              />{" "}
            </svg>

            {/* <Online>
              {" "}
              <svg
                id="pingIcon"
                xmlns="http://www.w3.org/2000/svg"
                className={"h-6 w-6 text-" + pingColor + "-400"}
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                strokeWidth="2"
              >
                {" "}
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M8.111 16.404a5.5 5.5 0 017.778 0M12 20h.01m-7.08-7.071c3.904-3.905 10.236-3.905 14.141 0M1.394 9.393c5.857-5.857 15.355-5.857 21.213 0"
                />{" "}
              </svg>
            </Online> */}
            {/* <Offline>
              {" "}
              <div
                style={{
                  width: "400px",
                  position: "fixed",
                  bottom: "-100px",
                  right: "-10px",
                  backgroundColor: "#ff5b55",
                  color: "white",
                  borderRadius: "5px",
                  fontWeight: "500",
                }}
              >
                <div style={{ margin: "10px", display: "flex" }}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-6 w-6 mr-2"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    strokeWidth={2}
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M15 12H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z"
                    />
                  </svg>
                  Votre connexion à Comunik.VoIP semble être perdue. Pas de
                  panique, une tentative de connexion est en cours...
                </div>
              </div>
              <svg
                id="pingIcon"
                xmlns="http://www.w3.org/2000/svg"
                className={"h-6 w-6 text-red-900"}
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                strokeWidth="2"
              >
                {" "}
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M8.111 16.404a5.5 5.5 0 017.778 0M12 20h.01m-7.08-7.071c3.904-3.905 10.236-3.905 14.141 0M1.394 9.393c5.857-5.857 15.355-5.857 21.213 0"
                />{" "}
              </svg>
            </Offline> */}
          </div>
        )}
      </div>

      {session.length === 0 ? (
        isOpen ? (
          <>
            <Dropdown
              callClick={callClick}
              callClickVideo={callClickVideo}
              navbar={navbar}
              echecCurrentAppel={echecCurrentAppel}
              cancelEchecAppel={cancelEchecAppel}
              tab={tab}
            />
          </>
        ) : (
          <Dash />
        )
      ) : isOpen ? (
        <Callpage
          setState={setState}
          holdSession={holdSession}
          muteSession={muteSession}
          activecall={activecall}
          hungUp={hungUp}
          upBtn={upBtn}
          acceptappel={acceptappel}
          openmodel={openmodel}
          session={session}
          changeSession={changeSession}
          holdCall={holdCall}
          muteCall={muteCall}
          ConferenceCall={ConferenceCall}
          upBtnVideo={upBtnVideo}
          transfertCall={transfertCall}
          newcallClick={callClick}
          tab={tab}
          navbar={navbar}
          backHomeVariable={backHome}
          openBackHome={openBackHome}
          closeBackHome={closeBackHome}
          openBackHomeConference={openBackHomeConference}
          sendDTMF={sendDTMF}
          activeTransfert={activeTransfert}
          transfertCallAcc={transfertCallAcc}
          callTransfert={callTransfert}
        />
      ) : (
        <CallPageDown
          session={session}
          activecall={activecall}
          upBtn={upBtn}
          upBtnVideo={upBtnVideo}
          hungUp={hungUp}
          holdSession={holdSession}
          muteSession={muteSession}
          tab={tab}
        />
      )}
    </div>
  );
}

export default PhoneCpt;
